<div class="search-panel" [ngClass]="panelClass">
  <button
    type="button"
    class="search-icon search-icon-btn"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isSearchScreenOpen"
    [attr.aria-label]="i18n.t('shell.searchLocation')"
    (click)="openSearchScreen($event)">
    <img src="/static_images/ic_search.svg" alt="" />
  </button>
  <input
    #searchTriggerInput
    type="text"
    class="search-input"
    readonly
    [ngModel]="searchQuery"
    [placeholder]="i18n.t('shell.searchPlaceholder')"
    [attr.aria-invalid]="locationSearchError ? 'true' : null"
    [attr.title]="locationSearchError || null"
    aria-haspopup="dialog"
    [attr.aria-expanded]="isSearchScreenOpen"
    (click)="openSearchScreen($event)"
    (keydown.enter)="openSearchScreen($event)"
    (keydown.space)="openSearchScreen($event)" />

  <ng-content />
</div>

@if (isSearchScreenOpen) {
  <div
    class="location-search-backdrop"
    aria-hidden="true"
    (click)="closeSearchScreen($event)"></div>

  <section
    class="location-search-screen"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="i18n.t('shell.searchLocation')"
    (keydown.tab)="trapSearchScreenFocus($event)"
    (keydown.escape)="closeSearchScreen($event)">
    <div class="location-search-screen__bar">
      <button
        #searchCloseButton
        type="button"
        class="location-search-close"
        [attr.aria-label]="i18n.t('common.back')"
        (click)="closeSearchScreen($event)">
        <span aria-hidden="true"></span>
      </button>
      <button
        #searchSubmitButton
        type="button"
        class="search-icon search-icon-btn location-search-submit"
        [attr.aria-label]="i18n.t('shell.searchLocation')"
        [disabled]="isLocationSearching"
        (click)="searchLocation($event)">
        <img src="/static_images/ic_search.svg" alt="" />
      </button>
      <input
        #searchScreenInput
        type="text"
        class="search-input location-search-screen__input"
        [(ngModel)]="searchQuery"
        [placeholder]="i18n.t('shell.searchPlaceholder')"
        [attr.aria-invalid]="locationSearchError ? 'true' : null"
        [attr.title]="locationSearchError || null"
        (input)="onLocationSearchInput()"
        (focus)="onLocationSearchFocus()"
        (blur)="hideLocationSuggestionsSoon()"
        (keydown.enter)="searchLocation($event)" />
    </div>

    @if (showLocationSuggestions) {
      <div class="location-search-results">
        @if (showingRecentLocationSearches) {
          @for (recent of recentLocationSearches; track recent.id) {
            <button
              type="button"
              class="location-search-option"
              (mousedown)="selectRecentLocationSearch(recent, $event)">
              <span class="location-search-option__title">{{ recent.label }}</span>
            </button>
          }
        } @else {
          @for (suggestion of locationSuggestions; track suggestion.id) {
            <button
              type="button"
              class="location-search-option"
              (mousedown)="selectLocationSuggestion(suggestion, $event)">
              <span class="location-search-option__title">{{ suggestion.title }}</span>
              @if (suggestion.subtitle) {
                <span class="location-search-option__subtitle">{{ suggestion.subtitle }}</span>
              }
            </button>
          }
        }
      </div>
    }
  </section>
}
